<!--
 * @Description:
 * @Date: 2019-05-20 16:39:57
 -->
<template>
  <div>
    <el-menu
      :default-active="activeKey"
      class="home-menu"
      mode="horizontal"
      @select="handleSelect"
    >
      <template v-for="(item, index) in menus">
        <el-menu-item
          :key="index"
          :index="item.name"
          @select="handleSelect"
          v-if="!item.child"
        >
          {{ item.label }}
        </el-menu-item>
        <el-submenu
          :key="index"
          v-else
          :index="item.name"
          @select="handleSelect"
        >
          <template slot="title">{{ item.label }}</template>
          <el-menu-item
            v-for="(item2, index2) in item.child"
            :key="index2 + 10"
            :index="item2.name"
          >
            {{ item2.label }}
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      activeKey: 'home'
    };
  },
  components: {},
  watch: {},
  computed: {
    ...mapGetters(['menus'])
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push({
        name: key
      });
    }
  },
  created() {
    this.activeKey = this.$route.name;
    console.log(this.menus);
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.home-menu {
  padding: 0 5%;
  width: 100%;
  border-bottom: none !important;
  .el-menu-item,
  .el-submenu .el-submenu__title {
    height: 5.4vh;
    line-height: 5.4vh;
  }
}
</style>
